/* eslint-disable max-len */
import ComingSoonImgReports from 'images/modals/ComingSoon-1.png';
import ComingSoonImgEmailAlerts from 'images/modals/ComingSoon-2.png';
import ComingSoonImgContentShare from 'images/modals/ComingSoon-3.png';
import ComingSoonImgInsightsExport from 'images/modals/ComingSoon-4.png';

const imageMap = {
  reports: ComingSoonImgReports,
  emailAlerts: ComingSoonImgEmailAlerts,
  contentSharing: ComingSoonImgContentShare,
  insightsExport: ComingSoonImgInsightsExport,
};

const dataMap = {
  reports: {
    title: 'Reports',
    image: imageMap.reports,
    imagePosition: 'right center',
    content:
      'In just a few clicks, Blueprint Reports delivers the most insightful data & analysis about any brands or publishers that grab you. Generate comprehensive insights comparing top-performing content, brands, publishers, keywords, and social channels. Generate it once, and we will automate it so it gets sent to you every week, month, quarter, or year.',
  },
  emailAlerts: {
    title: 'Email Alerts',
    image: imageMap.emailAlerts,
    imagePosition: 'right center',
    content:
      'With Email Alerts, you’ll receive weekly or monthly notifications for the content that matters to you. We can tell you when a competitor publishes new content, or even when your own brand does. We’re flexible, you choose your own schedule and the content you want to stay on top of.',
  },
  contentSharing: {
    title: 'Content Sharing',
    image: imageMap.contentSharing,
    imagePosition: 'left center',
    content:
      'This one’s pretty simple. If you see a piece of content that you want to share with a co-worker you simply click this button, add their email and a nice little digital airplane flies it instantly to them. First-class.',
  },
  insightsExport: {
    title: 'Insights Exports as PDF',
    image: imageMap.insightsExport,
    imagePosition: 'left center',
    content:
      'Exporting PDFs takes a snapshot of the most useful knowledge and insights from Blueprint.  Save the data you want, whether you’re filtering down, comparing across content, or both. Instantly create an insightful presentation for when you need to impress the boss or the boardroom.',
  },
};

export default dataMap;
